import apiClient from "@/api/client";
import type { CredentialItem, CredentialItemFormData } from "../types";

const wrap = <T>(res: { data: { data: T } }) => res.data.data;
const BASE = "/maintenance/credentials/";

const credentialApi = {
  list: () =>
    apiClient.get<{ data: CredentialItem[] }>(BASE).then(wrap),

  get: (id: string) =>
    apiClient.get<{ data: CredentialItem }>(`${BASE}${id}/`).then(wrap),

  create: (data: CredentialItemFormData) =>
    apiClient.post<{ data: CredentialItem }>(BASE, data).then(wrap),

  update: (id: string, data: Partial<CredentialItemFormData>) =>
    apiClient.patch<{ data: CredentialItem }>(`${BASE}${id}/`, data).then(wrap),

  remove: (id: string) => apiClient.delete(`${BASE}${id}/`),

  markRotated: (id: string) =>
    apiClient.post<{ data: CredentialItem }>(`${BASE}${id}/mark-rotated/`).then(wrap),
};

export default credentialApi;
